import { createSelector } from 'reselect'

import { RootState } from 'redux/store'
import { SearchType } from 'types/Search'

const selectCurrentSearchType = createSelector(
  (state: RootState) => state.search.currentSearchType,
  (currentSearchType: SearchType) => currentSearchType
)

export default selectCurrentSearchType
